import React, { useState } from 'react'

import {
  AlignItems,
  Box,
  Color,
  Display,
  JustifyContent,
  Space,
  Text,
  colors,
  Button,
  Icon,
} from '@gousto-internal/citrus-react'

import { Sidebar } from '../Sidebar/Sidebar'

type MenuPreferencesProps = {
  variant: 'desktop' | 'mobile'
}

export const MenuPreferencesButton = ({ variant }: MenuPreferencesProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [isButtonHovered, setIsButtonHovered] = useState(false)

  const toggleSidebar = () => {
    setIsOpen(!isOpen)
  }

  const color = isButtonHovered ? Color.Secondary_400 : Color.ColdGrey_900

  return (
    <Box display={Display.Flex} justifyContent={JustifyContent.FlexEnd}>
      <Box
        data-testid="menu-preferences-button"
        role="button"
        display={Display.Flex}
        alignItems={AlignItems.Center}
        color={color}
        onClick={toggleSidebar}
        onKeyDown={toggleSidebar}
        tabIndex={0}
        onMouseEnter={() => setIsButtonHovered(true)}
        onMouseLeave={() => setIsButtonHovered(false)}
        style={{ cursor: 'pointer' }}
      >
        {variant === 'desktop' && (
          <>
            <Text size={3}>Preferences</Text>
            <Space size={2} direction="horizontal" />
          </>
        )}
        <Icon name="preferences" color={colors[color]} />
      </Box>

      <Sidebar onClose={toggleSidebar} isOpen={isOpen}>
        {/* TODO: To be replaced by modal content, adding for testing purposes */}
        <Button onClick={toggleSidebar} data-testid="sidebar-close-button">
          Close
        </Button>
      </Sidebar>
    </Box>
  )
}
